import React, { useState } from "react";
import Offcanvas from "react-bootstrap/Offcanvas";
import { Link } from "react-router-dom";
import SocialFlow from "../Components/Contact";
import { motion } from "framer-motion";

export function TestNav() {
  const [show, setShow] = useState(false);

  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  return (
    <motion.div
      initial={{ x: "-100vw" }}
      animate={{ x: 0 }}
      transition={{ delay: 0.3, duration: 0.8 }}
      className={`z-50 sticky-top flex justify-center py-3`}
    >
      <div className="mx-auto ">
        <button
          onClick={handleShow}
          className="text-center text-decoration-none hover:text-black   p-4  azkare   mx-auto"
        >
          اذكاري
        </button>
      </div>

      <Offcanvas show={show} onHide={handleClose}>
        <Offcanvas.Header closeButton></Offcanvas.Header>
        <Offcanvas.Body>
          <div className={`flex justify-center flex-col gap-3`}>
            <Link
              onClick={handleClose}
              className={`text-center bg-slate-500 text-bold hover:bg-slate-600 text-decoration-none text-white   fs-2 rounded-lg`}
              to="/"
            >
              الصفحة الرئيسية
            </Link>
            <Link
              onClick={handleClose}
              className={`text-center bg-slate-500 text-bold hover:bg-slate-600 text-decoration-none text-white   fs-2 rounded-lg`}
              to="/morning"
            >
              اذكار الصباح
            </Link>
            <Link
              onClick={handleClose}
              className={`text-center bg-slate-500 text-bold hover:bg-slate-600 text-decoration-none text-white   fs-2 rounded-lg`}
              to="/evening"
            >
              اذكار المساء
            </Link>
            <Link
              onClick={handleClose}
              className={`text-center bg-slate-500 text-bold hover:bg-slate-600 text-decoration-none text-white   fs-2 rounded-lg`}
              to="/gettingUp"
            >
              اذكار الاستيقاظ
            </Link>
            <Link
              onClick={handleClose}
              className={`text-center bg-slate-500 text-bold hover:bg-slate-600 text-decoration-none text-white   fs-2 rounded-lg`}
              to="/afterPrayer"
            >
              اذكار بعد الصلاة
            </Link>
          </div>
          <SocialFlow />
          <div className="absolute bottom-0 text-center me-3 bg-slate-100 rounded-lg">
            <p>جميع الحقوق محفوظة © 2023 محمد مخلص , محمود عبدﷲ</p>
          </div>
        </Offcanvas.Body>
      </Offcanvas>
    </motion.div>
  );
}
